import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function PageLoader() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Check if we've already shown the loader in this session
    const hasLoaded = sessionStorage.getItem('hasLoaded');
    if (hasLoaded) {
      setIsLoading(false);
      return;
    }
    const timer = setTimeout(() => {
      setIsLoading(false);
      sessionStorage.setItem('hasLoaded', 'true');
    }, 2500);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-426">
      {isLoading && <motion.div initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0a1628]" data-id="element-427">
          <div className="relative mb-8" data-id="element-428">
            <div className="flex items-center gap-3 bg-white/95 backdrop-blur-sm border-2 border-[#d4a853]/30 rounded-lg px-8 py-4" data-id="element-429">
              <div className="bg-[#d4a853] text-[#0a1628] font-bold text-4xl px-4 py-2 rounded" data-id="element-430">
                888
              </div>
              <div className="text-[#0a1628] font-bold text-xl uppercase tracking-wider" data-id="element-431">
                Sourcing
                <br data-id="element-432" />
                Limited
              </div>
            </div>
          </div>

          <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="text-2xl font-bold tracking-[0.2em] text-white" data-id="element-433">
            888 SOURCING LIMITED
          </motion.div>

          <div className="mt-4 w-48 h-1 bg-[#1a2d4a] rounded-full overflow-hidden" data-id="element-434">
            <motion.div className="h-full bg-[#d4a853]" initial={{
          width: '0%'
        }} animate={{
          width: '100%'
        }} transition={{
          duration: 2.3,
          ease: 'easeInOut'
        }} data-id="element-435" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}